export const monitoring_general = {
  index: {
    title: 'Мониторинг'
  },
  
  tooltip: {
    index: 'Мониторинг доступен только для активных кампаний'
  }
};